module.exports = __webpack_public_path__ + "static/media/1.5e9615ce.jpg";